import { API, Storage } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";
export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    sellingMaterials(state) {
      return state.items.filter((material) => material.isOnSale);
    },
    material: (state) => {
      return (id) => {
        const material = state.items.filter((material) => material.id === id);

        if (!material) return null;
        return material[0];
      };
    },
  },
  actions: {
    async getMaterials({ commit }) {
      let items = [];
      let nextToken = null;
      do {
        const results = await API.graphql({
          query: queries.listMaterials,
          variables: { nextToken },
        });
        items = items.concat(results.data.listMaterials.items);
        nextToken = results.data.listMaterials.nextToken;
      } while (nextToken);

      //get latest image url
      items.forEach(async (item) => {
        if (item.images) {
          item.images.forEach(async (image) => {
            image.url = await Storage.get(image.key);
          });
        }
      });
      commit("setMaterials", items);
    },

    async createMaterial({ dispatch }, { data }) {
      await API.graphql({
        query: mutations.createMaterial,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      const message = "材が登録されました";
      dispatch("utils/openSnackbar", message, { root: true });
      //STATEの更新
      dispatch("getMaterials");
    },
    async updateMaterial({ dispatch }, { id, form }) {
      const data = { id, ...form };
      console.log(data);
      await API.graphql({
        query: mutations.updateMaterial,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      const message = "材料情報を更新しました";
      dispatch("utils/openSnackbar", message, { root: true });
      //STATEの更新
      dispatch("getMaterials");
    },
    async deleteMaterial({ state, dispatch }, { item }) {
      const data = { id: item.id }; // 削除したい材料のIDを入れる
      await API.graphql({
        query: mutations.deleteMaterial,
        variables: { input: data },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      const i = state.items.indexOf(item);
      if (i > -1) {
        state.items.splice(i, 1);
      }
      const message = "材料情報を削除しました";
      dispatch("utils/openSnackbar", message, { root: true });
      //STATEの更新
      dispatch("getMaterials");
    },
  },
  mutations: {
    setMaterials(state, materials) {
      state.items = materials;
    },
  },
};
